// chat-floating.component.ts
import { Component, OnInit, OnDestroy, ElementRef, ViewChild, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { setting } from '../../../../setting';

interface ChatMessage {
  id: string;
  text: string;
  sender: 'user' | 'bot';
  timestamp: Date;
  isLoading?: boolean;
  app_id: number;
  client_id: number;
  user_application_id: number
}

@Component({
  selector: 'app-chat-floating',
  templateUrl: './chat-floating.component.html',
  styleUrls: ['./chat-floating.component.scss']
})
export class ChatFloatingComponent implements OnInit, OnDestroy {
  @ViewChild('messagesContainer') messagesContainer!: ElementRef;
  @Input() user: any;
  @Input() appId: number = -1;

  isOpen = false;
  newMessage = '';
  isLoading = false;
  messages: ChatMessage[] = [];
  private apiUrl = setting.fusionPaxTest; // Cambiar por la URL de tu API

  constructor(
    private http: HttpClient,
    // private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    console.log(this.user)
    // Cargar historial desde localStorage
    const saved = localStorage.getItem('chat_history');
    if (saved) {
      try {
        this.messages = JSON.parse(saved);
      } catch {
        this.messages = [];
      }
    }
  }

  toggleChat(): void {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      setTimeout(() => this.scrollToBottom(), 100);
    }
  }

  sendMessage(): void {
    const text = this.newMessage.trim();
    if (!text || this.isLoading) return;

    // Mensaje del usuario
    const userMsg: ChatMessage = {
      id: Date.now().toString(),
      text: text,
      sender: 'user',
      timestamp: new Date(),
      app_id: this.appId,
      client_id: this.user?.clientFx.id,
      user_application_id: this.user?.id,
    };
    this.messages.push(userMsg);
    this.newMessage = '';
    this.saveMessages();
    this.scrollToBottom();

    // Indicador de carga
    const loadingMsg: ChatMessage = {
      id: 'loading',
      app_id: this.appId,
      client_id: this.user?.clientFx.id,
      user_application_id: this.user?.id,
      text: '',
      sender: 'bot',
      timestamp: new Date(),
      isLoading: true
    };
    this.messages.push(loadingMsg);
    this.isLoading = true;

    const payload = {
      app_id: this.appId,
      client_id: this.user?.clientFx.id,
      user_application_id: this.user?.id.toString(),
      message: text
    }


    // Llamar a la API
    this.http.post<any>(this.apiUrl, payload)
    .subscribe({
      next: (response) => {
        this.messages = this.messages.filter(m => m.id !== 'loading');
        this.messages.push({
          id: Date.now().toString(),
          text: response.data?.reply?.content || 'Gracias por tu mensaje. ¿En qué más puedo ayudarte?',
          sender: 'bot',
          timestamp: new Date(),
          app_id: this.appId,
          client_id: this.user?.clientFx.id,
          user_application_id: this.user?.id,
        });
        this.isLoading = false;
        this.saveMessages();
        this.scrollToBottom();
      },
      error: (error) => {
        console.error('Error en chat:', error);
        this.messages = this.messages.filter(m => m.id !== 'loading');
        this.messages.push({
          id: Date.now().toString(),
          text: 'Lo siento, hubo un error. Por favor intenta de nuevo.',
          sender: 'bot',
          timestamp: new Date(),
          app_id: this.appId,
          client_id: this.user?.clientFx.id,
          user_application_id: this.user?.id,
        });
        this.isLoading = false;
        this.saveMessages();
        this.scrollToBottom();
        // this.notificationService.error('Error al conectar con el asistente');
      }
    });
  }

  private getChatContext(): string {
    // Enviar historial reciente para contexto
    return this.messages
      .filter(m => m.id !== 'loading')
      .slice(-10)
      .map(m => `${m.sender}: ${m.text}`)
      .join('\n');
  }

  private scrollToBottom(): void {
    setTimeout(() => {
      if (this.messagesContainer) {
        const element = this.messagesContainer.nativeElement;
        element.scrollTop = element.scrollHeight;
      }
    }, 50);
  }

  private saveMessages(): void {
    // Guardar solo los últimos 50 mensajes
    localStorage.setItem('chat_history', JSON.stringify(this.messages.slice(-50)));
  }

  ngOnDestroy(): void {
    // Limpiar si es necesario
  }

  sendQuickSuggestion(text: string): void {
  this.newMessage = text;
  this.sendMessage();
}
}